// src/components/MyAI/MyAI.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Image, MessageSquare, FileText, Music, Video, Code } from 'lucide-react';
import './MyAI.css';

const MyAI = ({ user, userProfile }) => {
    const navigate = useNavigate();

    const aiServices = [
        {
            id: 'flux2image',
            icon: Image,
            title: 'Flux2Image',
            description: 'AI 기반 이미지 생성 서비스',
            status: 'active',
            route: '/myai/flux2image'
        },
        {
            id: 'chat',
            icon: MessageSquare,
            title: 'AI Chat',
            description: '지능형 대화 서비스',
            status: 'coming',
            route: '/myai/chat'
        },
        {
            id: 'document',
            icon: FileText,
            title: 'Document AI',
            description: '문서 분석 및 생성',
            status: 'coming',
            route: '/myai/document'
        },
        {
            id: 'music',
            icon: Music,
            title: 'Music AI',
            description: 'AI 음악 생성',
            status: 'coming',
            route: '/myai/music'
        },
        {
            id: 'video',
            icon: Video,
            title: 'Video AI',
            description: 'AI 비디오 생성',
            status: 'coming',
            route: '/myai/video'
        },
        {
            id: 'code',
            icon: Code,
            title: 'Code AI',
            description: 'AI 코드 어시스턴트',
            status: 'coming',
            route: '/myai/code'
        }
    ];

    const handleServiceClick = (service) => {
        if (service.status === 'active') {
            navigate(service.route);
        }
    };

    return (
        <div className="myai-container">
            <div className="myai-header">
                <h2 className="myai-title">MyAI Services</h2>
                <p className="myai-subtitle">AI 기반 다양한 서비스를 경험해보세요</p>
            </div>

            <div className="myai-services-grid">
                {aiServices.map((service) => (
                    <div
                        key={service.id}
                        className={`myai-service-card ${service.status === 'active' ? 'active' : 'coming'}`}
                        onClick={() => handleServiceClick(service)}
                    >
                        <div className="service-icon-wrapper">
                            <service.icon className="service-icon" />
                        </div>
                        <h3 className="service-title">{service.title}</h3>
                        <p className="service-description">{service.description}</p>
                        {service.status === 'coming' && (
                            <div className="service-badge">Coming Soon</div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MyAI;